import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const validateStep = (step: number, maxValue: number = undefined): ValidatorFn => {
  if (step <= 0) {
    throw new Error(`Step must be greater than zero, ${step} provided`);
  }

  return (control: AbstractControl): ValidationErrors | null => {
    const valueInStep = control.value % step === 0;
    const isMaxValue = maxValue && control.value === maxValue;
    return valueInStep || isMaxValue ? null : { invalidStepSize: true };
  };
};
